import * as React from "react"
import { useForm, FormProvider } from "react-hook-form"
import { Box, Button, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { TextInput, NullableBooleanInput, useListContext, SelectInput, ReferenceInput, AutocompleteInput } from "react-admin"
import { useEffect } from "react"

const LogoFilterForm = () => {
  const {
    displayedFilters,
    filterValues,
    setFilters,
    hideFilter
  } = useListContext()

  const form = useForm({
    defaultValues: {
      ...filterValues,
      q: filterValues.q || '',  // 預設值
    }
  });

  useEffect(() => {
    if (!displayedFilters.main) {
      form.reset();  // 當篩選器隱藏時重置表單
    }
  }, [displayedFilters.main]);  // 只在displayedFilters.main變更時執行

  if (!displayedFilters.main) return null

  const onSubmit = values => {
    if (Object.keys(values).length > 0) {
      setFilters(values)
    } else {
      hideFilter("main")
    }
  }

  const resetFilter = () => {
    form.reset()
    setFilters({}, [])
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box display="flex" alignItems="flex-end" mb={1}>
          <Box component="span" mr={2}>
            {/* Full-text search filter. We don't use <SearchFilter> to force a large form input */}
            <TextInput
              resettable
              helperText={false}
              source="q"
              label="搜尋"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon color="disabled" />
                  </InputAdornment>
                )
              }}
            />
          </Box>
          <Box component="span" mr={2}>
            <ReferenceInput source="members" 
              reference="members" 
              sort={{ field: 'createdAt', order: 'ASC' }}
              >
              <AutocompleteInput 
                label="隸屬會員"
                helperText={false} // Disable extra helper text
              />
            </ReferenceInput>
          </Box>
          <Box component="span" mr={2}>
            <SelectInput
              resettable
              source="reviewStatus"
              label="審核狀態"
              emptyText="全部"
              helperText={false} // Disable extra helper text
              choices={[
                { id: 'pending', name: '待審核' },
                { id: 'approved', name: '審核通過' },
                { id: 'rejected', name: '審核未通過' },
              ]}
            />
          </Box>
          <Box component="span" mr={2} mb={1.5}>
            <Button variant="outlined" color="primary" type="submit">
              篩選
            </Button>
          </Box>
          <Box component="span" mb={1.5}>
            <Button variant="outlined" onClick={resetFilter}>
              關閉
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  )
}

export default LogoFilterForm;